/* =============================================================================
 * [OS-LEGADO-CONGELADO] ARQUIVO TEMPORARIO - APAGAR APOS VALIDACAO
 * =============================================================================
 * Copia CONGELADA do modulo antigo de "OS para coleta" (versao que estava em
 * producao antes da entrada do modulo novo).
 *
 * Origem desta copia: src/Components/CustomUi/warning/styles.ts
 * Papel: componente compartilhado congelado
 *
 * POR QUE ISSO EXISTE
 *   O modulo novo de OS substituiu o antigo. Esta copia fica disponivel por
 *   ~1 SEMANA como plano de contingencia: se o modulo novo apresentar
 *   problema, o time volta a usar esta versao sem interromper o trabalho.
 *
 * NAO EDITE ESTE ARQUIVO
 *   Ele e um retrato fiel do comportamento antigo. Qualquer correcao deve ser
 *   feita no modulo NOVO. Editar aqui destroi o valor da copia.
 *
 * COMO APAGAR (quando o modulo novo for validado)
 *   1. Remover a pasta inteira: src/Views/app/precisao/OSAntigaLegado/
 *   2. Remover a rota/menu marcado com [OS-LEGADO-CONGELADO] em
 *      src/Configs/Navegacao.ts
 *   3. Conferir que nao sobrou nenhuma referencia:
 *        grep -rn "OSAntigaLegado\|OS-LEGADO-CONGELADO" src/
 *   Nada fora desta pasta depende dela, entao a remocao e segura.
 * ========================================================================== */

import styled from "styled-components";

export const Aviso = styled.div`
    width: 100%;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 7px 10px;
    background: var(--hover-color);
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: var(--text-color);

    :is([data-type = 'success']) {
        background: rgba(137, 197, 88, 0.1);
        color: #8AC558;
    }
    :is([data-type = 'danger']) {
        background: rgba(255, 77, 79, 0.1);
        color: #FF4D4F;
    }
    :is([data-type = 'error']) {
        background: rgba(255, 77, 79, 0.1);
        color: #FF4D4F;
    }
    :is([data-type = 'warning']) {
        background: #FEFAE9;
        color: #ef7918;
    }
    /* :is([data-type = 'warning']) {
        background: #FFF0D9;
        color: #DF8600;
    } */
    :is([data-type = 'info']) {
        background: #bdd1fc;
        color: #2F54EB;
    }

`